import { render } from "./TrafficBoard.vue?vue&type=template&id=76a8a7be"
import script from "./TrafficBoard.vue?vue&type=script&lang=js"
export * from "./TrafficBoard.vue?vue&type=script&lang=js"

import "./TrafficBoard.vue?vue&type=style&index=0&id=76a8a7be&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__